
import React from 'react';
import { InteractiveCheckbox } from './InteractiveCheckbox';

interface MarkdownRendererProps {
  content: string;
  onContentChange: (newContent: string) => void;
  readonly?: boolean;
}

export const MarkdownRenderer = ({ content, onContentChange, readonly = false }: MarkdownRendererProps) => {
  const toggleCheckbox = (lineIndex: number, checked: boolean) => {
    if (readonly) return;
    
    const lines = content.split('\n');
    const line = lines[lineIndex];
    
    if (line.match(/^- \[([ x])\]/)) {
      const newLine = checked 
        ? line.replace(/^- \[ \]/, '- [x]')
        : line.replace(/^- \[x\]/, '- [ ]');
      lines[lineIndex] = newLine;
      onContentChange(lines.join('\n'));
    }
  };

  const renderContent = () => {
    if (!content) return null;
    
    const lines = content.split('\n');
    const elements: React.ReactNode[] = [];
    let currentBlock: string[] = [];
    let blockType = 'text';
    
    const flushBlock = () => {
      if (currentBlock.length === 0) return;
      
      if (blockType === 'text') {
        const text = currentBlock.join('\n');
        if (text.trim()) {
          elements.push(
            <div key={elements.length} className="whitespace-pre-wrap mb-2">
              {text}
            </div>
          );
        }
      }
      currentBlock = [];
    };
    
    lines.forEach((line, index) => {
      if (line.match(/^- \[([ x])\]/)) {
        flushBlock();
        const checked = line.includes('[x]');
        const text = line.replace(/^- \[([ x])\]\s*/, '');
        
        elements.push(
          <InteractiveCheckbox 
            key={`checkbox-${index}`}
            checked={checked}
            onChange={(newChecked) => toggleCheckbox(index, newChecked)}
          >
            {text}
          </InteractiveCheckbox>
        );
      } else {
        if (blockType !== 'text') {
          flushBlock();
          blockType = 'text';
        }
        currentBlock.push(line);
      }
    });
    
    flushBlock();
    
    return elements;
  };

  return (
    <div className="prose max-w-none">
      {renderContent()}
    </div>
  );
};
